import { FC, useState } from 'react'
import { GetSelfUser } from 'src/services/napi/getSelf/interfaces/getSelf.interface'
import { UpdateSelfParams } from 'src/services/napi/updateSelf/interfaces/updateSelf.interface'
import { UpdateSelfPasswordParams } from 'src/services/napi/updateSelfPassword/interfaces/updateSelfPassword.interface'
import PersonalInformation from './PersonalInformation'
import ProfileImage from './ProfileImage'
import styles from './yourAccount.module.scss'

interface YourAccountProps {
  handleUpdatePassword: (params: UpdateSelfPasswordParams) => Promise<boolean>
  handleUpdateUser: (
    params: UpdateSelfParams,
    successMessage?: string
  ) => Promise<boolean>
  userData?: GetSelfUser
}

const YourAccount: FC<YourAccountProps> = ({
  userData,
  handleUpdateUser,
  handleUpdatePassword,
}) => {
  const [isSaving, setIsSaving] = useState<boolean>(false)

  return (
    <div className={styles.yourAccount}>
      <div className={styles.container}>
        <PersonalInformation
          handleUpdatePassword={handleUpdatePassword}
          handleUpdateUser={handleUpdateUser}
          onSavingChange={setIsSaving}
          userData={userData}
        />
        <ProfileImage userName={userData?.firstName || 'User'} />
      </div>
      <div className={styles.buttonContainer}>
        <button
          className={styles.doscardBtn}
          disabled={isSaving}
          form="personalInformationForm"
          type="reset"
        >
          Discard
        </button>
        <button
          className={styles.saveBtn}
          disabled={isSaving}
          form="personalInformationForm"
          type="submit"
        >
          {isSaving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  )
}

export default YourAccount
